var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42202 3.15802C11.2986 0.280104 15.964 0.281215 18.8417 3.15802C21.7194 6.03483 21.7194 10.7006 18.8417 13.5785M15.7374 13.6308C15.7374 17.7007 12.4383 21 8.36868 21C4.29907 21 1 17.7007 1 13.6308C1 9.56083 4.29907 6.26151 8.36868 6.26151C12.4383 6.26151 15.7374 9.56083 15.7374 13.6308Z",
    stroke: "#6F6E84",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon);
export default __webpack_public_path__ + "static/media/overviewIcon.978867bc.svg";
export { ForwardRef as ReactComponent };